<template>
	<div class="l-body">
		<top/>
	<!-- <div class="header">
	<div class="l-wrap">
	<a class="header__logo" href="https://www.zhaouc.com/" target="_blank">塔人网络</a>
	<el-dropdown class="news_nav">
		<span>
			游戏充值
		</span>
		<el-dropdown-menu slot="dropdown">
			<el-dropdown-item><a href="http://pay.tarenwang.com/" target="_blank">MU、SUN</a></el-dropdown-item>
		    <el-dropdown-item><a href="http://trpay.zhaouc.com/" target="_blank">RO</a></el-dropdown-item>
		</el-dropdown-menu>
	</el-dropdown>
	<el-dropdown class="news_nav">
		<span>
			帐号管理
		</span>
		<el-dropdown-menu slot="dropdown">
		    <el-dropdown-item><a href="http://yht.zhaouc.com/" target="_blank">MU、SUN</a></el-dropdown-item>
		    <el-dropdown-item><a href="http://roinfo.zhaouc.com/" target="_blank">RO</a></el-dropdown-item>
		</el-dropdown-menu>
	</el-dropdown>
	<a class="news_nav" href="http://www.zhaouc.com/" target="_blank">塔人主站</a>
	<a class="news_nav" href="/">客服首页</a>
	</div>
	</div> -->
	<div class="wrap login_bg">
	<div class="login zheng">
	<div class="login_dl">
	<div class="login_box">
	<h1>魔力宝贝登录</h1>
		<div id="login_frame" class="login_frame">
			<form id="form" class="login_form" name="form">
				<div class="login_table">
					<!-- 用户信息填写表单 -->
					<div id="tbody_user" class="tbody" style="position: relative">
						<!-- 用户名 -->
						<div id="user_name" class="tr">
							<div id="user_name_input" class="cell_input with_icon">
								<span class="td">
								  <input type="text" id="account" name="account" tabindex="1" class="text username" maxlength="11" placeholder="手机号" autocomplete="off" v-model="name">
								</span>
							</div>
						</div>
						<!--用户名 -->
						<div id="user_code" class="tr" >
							<div class="form_tips" style="display: block;background:#eee;line-height:2;padding:0 10px"  @click="flash">刷新极客验证</div>
							<div class="form-group" style="margin:10px 0" >
								<div id="embed-captcha">
									<div id="wait" class="show">正在加载极客验证......</div>
									<div id="notice" class="hide">请先完成验证</div>
								</div>
							</div>
						</div>
						<!-- 密码 -->
						<div id="user_pwd" class="tr">
							<div id="user_pwd_input" class="cell_input with_icon">
								<span class="td">
								  <input type="password" tabindex="2" id="password" autocomplete="off"  name="password" class="text password" maxlength="6" placeholder="验证码" v-model="poss" style="width: 133px;">
								  <el-button slot="append" :disabled="!canClick" @click="getpass()" style="padding-top: 10px;">{{ getCode }}</el-button>
								</span>
							</div>
						</div><!--密码 -->
					</div>
					<!--用户名 -->
					<!-- <div class="no_reg">
						<div class="ui_btn ui_btn_gray">
						  <div style="float:left">
		<el-checkbox v-model="chk">记住密码</el-checkbox>
	</div>

						</div>
					</div> -->

					<!-- 表单提交按钮 -->
					<div id="tbody_btn" class="tbody" >
						<div id="login_btn" class="tr">
							<div class="login_btn">
								<span class="td">
									<input class="submit_btn" id="submit" tabindex="40" value="登 录" @click="sub()">
									<div style="clear:both"></div>
								</span>
							</div>
						</div>
					</div>
					<!--表单提交按钮 -->
				</div>
			</form>
		</div>
	</div>
	</div>
	</div>
	</div>
	</div>
</template>

<script>
	import top from '@/components/top1.vue'
	export default {
	  name: 'mlogin',
	  components: {
	    top
	  },
	  data () {
	    return {
		name:'',
		poss:'',
		getCode:'获取验证码',
		canClick:true, // 验证码是否禁用
		totalTime:60
		//chk:false
	    }
	  },
    mounted(){
	window.geetResetAjax();
	//this.getLs();
    },
    methods:{
      flash(){
        window.geetResetAjax();
      },
	  getpass(){
		  var num=this.name
		  //@ts-ignore
		  var isverify = $('.geetest_success_radar_tip_content').html();
		  if (!num){
		    this.$message({
		      type: 'error',
		      message: '手机号不能为空！',
		      offset:300
		    });
		  }else if(! /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/.test(num)){
			  this.$message({
			    type: 'error',
			    message: '请输入正确的11位手机号码！',
			    offset:300
			  });
		  }else if(isverify != '验证成功') {
		    this.$message({
				type: 'error',
				message: '验证不通过！',
				offset:300
		    });
		  }else{
		    this.$axios({
		      method: 'post',
		      url: '/index.php/user/User/shownumber',
		      data: {
		        phone:num,
				geetest_challenge:$("input[name='geetest_challenge']").val(),
				geetest_validate:$("input[name='geetest_validate']").val(),
				geetest_seccode:$("input[name='geetest_seccode']").val()
		      }
		    }).then(res => {
		    	if(res.status==200){
		    		this.verificationCode()
					this.$message({
					  message: '正在发送',
					  offset:300
					});
		    	}
		    })
		  }
	  },
	  verificationCode () {
	     if (!this.canClick) return  
	     this.canClick = false
	     this.getCode = this.totalTime + 's后重新发送'
	     let clock = window.setInterval(() => {
	       this.totalTime--
	       this.getCode = this.totalTime + 's后重新发送'
	       if (this.totalTime < 0) {
	         window.clearInterval(clock)
	         this.getCode = '重新发送验证码'
	         this.totalTime = 60
	         this.canClick = true  
	       }
	     },1000)
	   },
		sub(){
			if(this.name.length==0){
				this.$message({
				  type: 'error',
				  message: '手机号不能为空！',
				  offset:300
				});
				return false;
			}
			if(! /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/.test(this.name)){
				this.$message({
				type: 'error',
				message: '请输入正确的11位手机号码！',
				offset:300
				});
				return false;
			}
			if(this.poss.length==0){
				this.$message({
				  type: 'error',
				  message: '请输入验证码！',
				  offset:300
				});
				return false;
			}
            this.$axios({
              method: 'post',
              url: '/index.php/user/User/phonelogin',
              data: {
                phone:this.name,
                smscode:this.poss,
              }
            }).then(res => {
              //console.log(res.data)
              if(res.data.status==200){
				  // if (this.chk == true) {
				  // 	const info = { name: this.name, poss:this.poss};
				  // 	localStorage.setItem('cook', JSON.stringify(info));
				  // }else {
				  // 	localStorage.clear();
				  // }
				localStorage.setItem('phone', 1);
                this.$router.push({path:"/"})
              }else {
                this.$message({
                  type: 'error',
                  message: res.data.data,
				  offset:300
                });
              }
            })
	    },
		// getLs() {
		// 	var data1 = JSON.parse(localStorage.getItem('cook'));
		// 	if(data1&&data1.name){
		// 		this.name=data1.name
		// 		this.poss=data1.poss
		// 	}
		// }
	  }
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/mlogin.vue